import React from 'react'
import PropTypes from 'prop-types'
import styles from './footer.module.scss'
import { FooterLogos } from './footerLogos'
import { FooterLinks } from './footerLinks'
import { Container } from 'layout/container'
import { useCurrentYear } from 'hooks/useCurrentYear'
import { useCabinClass } from 'hooks/useCabinClass'

const logos = [
  {
    src: '/static/img/footer/wire-transfer.png',
    alt: 'wire-transfer',
  },
  {
    src: '/static/img/footer/american_express.svg',
    alt: 'american-express',
  },
  {
    src: '/static/img/footer/discover.svg',
    alt: 'discover',
  },
  {
    src: '/static/img/footer/mastercard.svg',
    alt: 'mastercard',
  },
  {
    src: '/static/img/footer/visa.svg',
    alt: 'visa',
  },
]

const links = [
  {
    tag: 'privacy policy',
    href: '/privacy',
  },
  {
    tag: 'about us',
    href: '/#about-us',
  },
]

const Footer = ({ defaultClass = 'economy' }) => {
  const cabinClassCtx = useCabinClass()
  const cabinClass = cabinClassCtx?.cabinClass ?? defaultClass

  return (
    <footer className={styles.footerContainer}>
      <Container>
        <div className={styles.footerBlock__disclaimerBlock}>
          <div className={styles.footerBlock__disclaimerText}>
            *Fare terms and conditions apply. All the airfares advertised on the website are for
            round-trip travel in {cabinClass} class cabin and include all taxes and fees (excl.
            baggage fees, imposed by the airlines). The quoted fares are the lowest fares to the
            advertised destination(s) from the lowest priced gateway for the low travel season.
            Cheapest transatlantic fares to Europe, Africa, Middle East, Indian Subcontinent are
            usually from the East Coast: New York/Washington. Cheapest transpacific fares to Asia
            and Oceania are usually from the West Coast: Los Angeles/San Francisco. Cheapest fares
            to Latin America and the Caribbean are usually from Florida: Miami. Lowest travel
            season: February-March and October-November. Most of the discounted fares requite up to
            21 day advance purchase, min. 7 days stay and allow max. 1 month stay. Ticketing must be
            completed within 24 hours after reservations are made. Prices are accurate at time of
            publication, but the number of discounted seats is limited and they may not be available
            on all travel dates. Savings up to 40% off are indicated of the full non-restricted
            published airfares of major airlines and may vary based on individual fare rules. Most
            of the discounted airline tickets are non-refundable. The fares now have flexible
            booking policy: free exchange may be available with many airlines (please, ask your
            agent about cancelation/exchange policy for each particular ticket). Airline refunds
            and/or future credits are subject to airline fare rules, policies and procedures. The
            fares and their governing rules are subject to change without prior notice. Other
            restrictions may apply.
          </div>
          <FooterLinks links={links} />
        </div>
        <div className={styles.footerBlock__logosBlock}>
          <FooterLogos logos={logos} />
          <div>© {useCurrentYear()} Discount Fares. All rights reserved.</div>
        </div>
      </Container>
    </footer>
  )
}

Footer.propTypes = {
  defaultClass: PropTypes.string,
}

export { Footer }
